import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { ConnectorProfile } from '../../../types/types';
import TextInput from '../../../components/TextInput';
import Form from '../../../components/Form';
import Button from '../../../components/Button';
import { formikSubmitDisabled } from '../../../lib/utils';
import { StyledText } from '../../../components/StyledText';
import { requiredUrlTest } from '../../../lib/validationSchemas';

interface ConnectorProfileEditProps {
  profile: ConnectorProfile
  open: boolean
  handleClose: () => void
  handleSubmit: (values: any) => void
}

const initialValues = (profile: ConnectorProfile) => ({
  firstName: profile.firstName || '',
  lastName: profile.lastName || '',
  email: profile.email || '',
  companyName: profile.companyName || '',
  linkedInProfileUrl: profile.linkedInProfileUrl || '',
  introduction: profile.introduction || ''
});

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required().trim(),
  lastName: Yup.string().required().trim(),
  email: Yup.string().email().required().trim(),
  companyName: Yup.string().required().trim(),
  linkedInProfileUrl: requiredUrlTest,
  introduction: Yup.string().required().trim()
});

const ConnectorEditProfile: React.FC<ConnectorProfileEditProps> = ({
  open,
  handleClose,
  handleSubmit,
  profile
}) => {
  const formik = useFormik({
    initialValues: initialValues(profile),
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true
  });

  const handleCancel = () => {
    handleClose();
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <Form formik={formik}>
        <DialogTitle disableTypography>
          <StyledText variant='h2'>Edit Profile</StyledText>
        </DialogTitle>
        <DialogContent>
          <TextInput
            type='text'
            fullWidth
            id='firstName'
            label='First Name'
            placeholder=''
          />
          <TextInput
            type='text'
            fullWidth
            id='lastName'
            label='Last Name'
            placeholder=''
          />
          <TextInput
            type='text'
            fullWidth
            id='email'
            label='Email'
            placeholder=''
          />
          <TextInput
            type='text'
            fullWidth
            id='companyName'
            label='Company'
            placeholder=''
          />
          <TextInput
            type='text'
            fullWidth
            id='linkedInProfileUrl'
            label='LinkedIn'
            placeholder=''
          />
          <TextInput
            type='text'
            fullWidth
            multiline
            rows={6}
            id='introduction'
            label='Summary'
            placeholder=''
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancel}
            type='button'
            variant='text'
            size='large'
          >
            Cancel
          </Button>
          {formik.isSubmitting ? <CircularProgress />
            : (
              <Button
                type='submit'
                variant='contained'
                disableElevation
                color='primary'
                size='large'
                disabled={formikSubmitDisabled(formik)}
              >
                Update
              </Button>
            )}
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default ConnectorEditProfile;
